import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { UiTextsContext, UserDataContext } from "../../../contexts/Contexts";
import { getAnotherUserInfoService } from "../../../../infrastructure/services/UsersService";
import DesktopSideBar from "./ResponsiveNavBar/DesktopSideBar";

export const OtherUserTemplate = ({ routes }) => {
  const { texts } = useContext(UiTextsContext);
  const { userData } = useContext(UserDataContext);

  const location = useLocation();
  const userInfo = location.state;

  const [relation, setRelation] = useState("");

  useEffect(() => {
    if (userInfo) {
      getOtherUserInfo(userInfo);
    }
  }, [location]);

  const getOtherUserInfo = async (profileUser) => {
    try {
      const userId = profileUser?.idUsuario;
      const info = await getAnotherUserInfoService(userData?.idUsuario, userId);
      setRelation(info?.Estatus);
    } catch (error) {
      console.error("An error occurred while getting user info, ", error);
    }
  };

  return (
    <DesktopSideBar
      routes={routes}
      userInfo={userInfo}
      relation={relation}
      uiTexts={texts}
    />
  );
};